import { FunctionComponent } from 'react';
import Button from '../../../../../../components/Button';
import styles from '../styles.module.scss';

type ShowAllButtonProps = {
    count: number;
    onClick: () => void;
};

const ShowAllButton: FunctionComponent<ShowAllButtonProps> = ({ count, onClick }) => {
    if (count < 2) {
        return null;
    }

    return (
        <Button className={styles.nakedButton} preset="default" onClick={onClick}>
            Show All ({count})
        </Button>
    );
};

export default ShowAllButton;
